import React from 'react';
import { DateInput } from 'react-admin-date-inputs';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';

type Props = {
  label: string,
  source: string
};

const DateInputWrapper = (props: Props) => (
  <DateInput
    label={props.label}
    options={{ format: 'YYYY-MM-DD', clearable: true }}
    parse={v => v && v.toISOString()}
    providerOptions={{ utils: MomentUtils }}
    source={props.source} />
);

export default DateInputWrapper;



// WEBPACK FOOTER //
// ./src/views/Common/Utils/DateInputWrapper.tsx